<template>
    <v-layout
        class="fill-height"
    >
        <v-container
            class="pt-16"
        >
            <v-row
                justify="center"
            >
                <v-col
                    cols="12"
                    md="6"
                    lg="4"
                >
                    <v-card>
                        <v-card-title>
                            <v-avatar
                                size="60"
                            >
                                <img
                                    alt="ASI Reisen Logo"
                                    src="../assets/logo-small.svg"
                                />
                            </v-avatar>
                            <p
                                class="ml-3"
                            >
                                ASI Contacts
                            </p>
                        </v-card-title>
                        <v-card-text>
                            <v-list
                                two-line
                            >
                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon>
                                            mdi-phone
                                        </v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <a
                                                class="accent--text"
                                                href="tel:0043512546000"
                                            >
                                                +43-512-54 60 00
                                            </a>
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                            Mon - Fri: 9 am - 6 pm Central European Time
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-divider
                                    inset
                                >
                                </v-divider>
                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon>
                                            mdi-email
                                        </v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <a
                                                class="accent--text"
                                                href="mailto:verkauf@asi.at"
                                            >
                                                verkauf@asi.at
                                            </a>
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                            Bookings
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon>
                                            mdi-email
                                        </v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <a
                                                class="accent--text"
                                                href="mailto:operations@asi.at"
                                            >
                                                operations@asi.at
                                            </a>
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                            Operations
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon>
                                            mdi-email
                                        </v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <a
                                                class="accent--text"
                                                href="mailto:invoice@asi.at"
                                            >
                                                invoice@asi.at
                                            </a>
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                            Invoice
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item>
                                    <v-list-item-icon>
                                        <v-icon>
                                            mdi-email
                                        </v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>
                                            <a
                                                class="accent--text"
                                                href="mailto:partner@asi.at"
                                            >
                                                partner@asi.at
                                            </a>
                                        </v-list-item-title>
                                        <v-list-item-subtitle>
                                            General
                                        </v-list-item-subtitle>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-layout>
</template>

<script>
    export default {

    }
</script>
